module.exports = __webpack_public_path__ + "img/maison16.276b4a41.jpg";